var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-custom-drawer',{attrs:{"title":"Archivos"}},[_c('custom-section-scroll',{attrs:{"master-styles":{
      padding: '0px 20px 20px 20px',
      height: 'calc(100% - 58px)',
    }}},[_c('ListItems',{attrs:{"id":"list-content"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }